<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';

import emitter from '@/utils/events';

export default defineComponent({
  name: 'CountdownTimer',
  setup() {
    const totalTime = 10 * 60;
    const timeLeft = ref(totalTime);
    const minutes = ref(Math.floor(timeLeft.value / 60));
    const seconds = ref(timeLeft.value % 60);

    const setTime = (timeLeft: number) => {
      minutes.value = Math.floor(timeLeft / 60);
      seconds.value = timeLeft % 60;
    };

    const updateTime = () => {
      if (timeLeft.value > 0) {
        setTime(timeLeft.value--);
      }
    };
    const resetTimer = () => {
      timeLeft.value = totalTime;
      setTime(totalTime);
    };

    let interval: number;
    onMounted(() => {
      interval = setInterval(updateTime, 1000);

      emitter.on('clear-codeInput', () => {
        resetTimer();
      });
    });

    onUnmounted(() => {
      clearInterval(interval);
      emitter.off('clear-codeInput');
    });

    return {
      minutes,
      seconds,
    };
  },
});
</script>

<template>
  <p class="text-blue-600 text-center">
    Código expira em: {{ minutes }}:{{ ('0' + seconds).slice(-2) }}
  </p>
</template>
